export default {
  namespaced: true,
  state: {
    dataList: [],
    guaranteeList: [
      { label: "不限", value: 0 },
      { label: "信用", value: 1 },
      { label: "抵押", value: 2 },
      { label: "质押", value: 3 },
      { label: "保证", value: 4 },
    ],
    typeList: [
      { label: "不限", value: 0 },
      { label: "贷款类", value: 1, amount: "贷款额度", rate: "年化利率", term: "贷款期限" },
      { label: "租赁类", value: 3, amount: "贷款额度", rate: "年化利率", term: "贷款期限" },
      { label: "保险类", value: 5, amount: "保险额度", rate: "保险费率", term: "保险期限" },
    ]
  }
}
